// Search up the DOM for the closest parent element with the defined class.
// Use like:
// getClosest(event.target, '.some-class');
export const getClosest = (elem, selector) => {
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;
};
